import QueryString from "qs"
import http from "../index"
import {
  apiListBuy,
  apiDetailBuy,
  apiListSale,
  apiDetailSale,
  apiListInventory,
  apiReportAgencyPurchase,
  apiReportAgencyPurchaseDetail,
  apiListSaleB2B,
  apiListInventoryB2B,
  apiExportData,
  apiExportDataInventory,
  apiReportAgencyPurchaseExport,
  apiReportAgencySellExport,
  apiGetReportAgencyInventoryDetail,
  apiReportAgencyInventoryExport,
  apiDetailSimSale,
  apiDetailSimPurchase,
  apiGetDetailInventory,
  apiGetSaleSettingReport,
  apiGetListRetailReport,
  apiGetReportAgencyRetailDetail,
  apiExportExcelReportRetail,
} from "./urls"

const getListBuy = params => http.get(apiListBuy, { params })
const getDetailBuy = id => http.get(apiDetailBuy(id))
const getListSale = params => http.get(apiListSale, { params })
const getDetailSale = id => http.get(apiDetailSale(id))
const getListInventory = params => http.get(apiListInventory, { params })
const getReportAgencyPurchase = params =>
  http.get(apiReportAgencyPurchase, { params })
const getReportAgencyPurchaseDetail = id =>
  http.get(apiReportAgencyPurchaseDetail(id))
const getListSaleB2B = params => http.get(apiListSaleB2B, { params })
const getListInventoryB2B = params => http.get(apiListInventoryB2B, { params })
const exportData = params =>
  http.get(apiExportData, { responseType: "blob", params: params })
const exportDataInventory = params =>
  http.get(apiExportDataInventory, { responseType: "blob", params: params })
const exportExcelReportAgencyPurchase = params =>
  http.get(apiReportAgencyPurchaseExport, { params, responseType: "blob" })
const exportExcelReportAgencySell = params =>
  http.get(apiReportAgencySellExport, { params, responseType: "blob" })
const getReportAgencyInventoryDetail = id =>
  http.get(apiGetReportAgencyInventoryDetail(id))
const exportExcelReportAgencyInventory = params =>
  http.get(apiReportAgencyInventoryExport, { params, responseType: "blob" })
const detailSimSale = id => http.get(apiDetailSimSale(id))
const detailSimPurchase = id => http.get(apiDetailSimPurchase(id))
const getDetailInventory = id => http.get(apiGetDetailInventory(id))
const getSaleSettingReport = params => http.get(apiGetSaleSettingReport, params)
const getListRetailReport = params =>
  http.get(apiGetListRetailReport, { params })
const getReportAgencyRetailDetail = id =>
  http.get(apiGetReportAgencyRetailDetail(id))
const exportExcelReportRetail = params =>
  http.get(apiExportExcelReportRetail, { params, responseType: "blob" })
const ReportService = {
  getListBuy,
  getDetailBuy,
  getListSale,
  getDetailSale,
  getListInventory,
  getReportAgencyPurchase,
  getReportAgencyPurchaseDetail,
  getListSaleB2B,
  getListInventoryB2B,
  exportData,
  exportDataInventory,
  exportExcelReportAgencyPurchase,
  exportExcelReportAgencySell,
  getReportAgencyInventoryDetail,
  exportExcelReportAgencyInventory,
  detailSimSale,
  detailSimPurchase,
  getDetailInventory,
  getSaleSettingReport,
  getListRetailReport,
  getReportAgencyRetailDetail,
  exportExcelReportRetail,
}

export default ReportService
